export default __webpack_public_path__ + "static/media/connect4.ce0719a5.png";